import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FileText, Loader2 } from "lucide-react";

// Anteprima visiva di un allegato: foto in miniatura o scheda PDF. Click = apre il file.
export const AttachmentThumb = ({ attId, mime, filename, previewUrl, testId }) => {
  const [url, setUrl] = useState(previewUrl || null);
  const [loading, setLoading] = useState(false);
  const isImage = (mime || "").startsWith("image/");

  useEffect(() => {
    if (previewUrl || !attId || !isImage) return;
    let objUrl;
    setLoading(true);
    api.get(`/attachments/${attId}`, { responseType: "blob" })
      .then((r) => { objUrl = URL.createObjectURL(r.data); setUrl(objUrl); })
      .catch(() => {})
      .finally(() => setLoading(false));
    return () => objUrl && URL.revokeObjectURL(objUrl);
  }, [attId, previewUrl, isImage]);

  const open = async () => {
    if (url) { window.open(url, "_blank"); return; }
    if (!attId) return;
    try {
      const r = await api.get(`/attachments/${attId}`, { responseType: "blob" });
      window.open(URL.createObjectURL(r.data), "_blank");
    } catch { alert("Impossibile aprire l'allegato"); }
  };

  if (isImage) {
    return (
      <button type="button" onClick={open} data-testid={testId} title={filename}
        className="block w-32 h-24 overflow-hidden rounded-md border border-labor-border bg-labor-skyBg flex-shrink-0 hover:opacity-90 transition-opacity">
        {loading || !url ? <Loader2 className="w-5 h-5 m-auto mt-9 animate-spin text-labor-muted" />
          : <img src={url} alt={filename} className="w-full h-full object-cover" />}
      </button>
    );
  }
  return (
    <button type="button" onClick={open} data-testid={testId} title={filename}
      className="flex items-center gap-2 w-56 max-w-full px-3 py-2 rounded-md border border-labor-border bg-white hover:bg-labor-skyBg transition-colors text-left">
      <div className="w-9 h-11 bg-red-600 text-white text-[10px] font-bold flex items-center justify-center rounded-sm flex-shrink-0">PDF</div>
      <div className="min-w-0">
        <div className="text-xs font-medium truncate text-labor-ink">{filename}</div>
        <div className="text-[10px] text-labor-muted flex items-center gap-1"><FileText className="w-3 h-3" /> {attId ? "Tocca per aprire" : "Documento PDF"}</div>
      </div>
    </button>
  );
};
